export const downloadFile = (data, nameFile = 'download.txt', typeMime = 'text/csv;charset=utf-8;' ) => {
  const universalBOM = "\uFEFF";
  const blob = new Blob([ universalBOM + data ], { type: typeMime });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, nameFile);
  } else {
    const url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.setAttribute("href", url);
    link.setAttribute('download', nameFile);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
